import { AuthLevel, generateApiPath } from '@guiker/api-definition'

const paths = {
  booking: generateApiPath({ prefix: AuthLevel.ADMIN, name: 'booking' }),
}

export { paths }
